
export const environment = {
	development: true,
	uat: false,
	staging: false,
	production: false,
	serviceURL: 'https://analytics-api.review-18.a.qa.frequence.rocks',
	build_branch_name: 'develop',
  build_owner_name: 'neha-naik-frequence',
  build_date: 'February 25 2026 00:44:10 PST',
  build_info: 'Reporting Dashboard Angular Library - Angular 15',
  build_jenkins_job_id: '5495',
  build_jenkins_job_name: 'Reporting Dashboard',
};
